import data from "../../.sourceflow/main_menu.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getMainMenu = (locale = "en") => {
  const collection = new BaseCollection(data, locale).getItems();

  // recursive helper
  const buildTree = (parentId = null) => {
    return collection
      .filter((item) => item.parent.id === parentId)
      .map((item) => ({
        ...item,
        children: buildTree(item.id) // recurse into children
      }));
  };

  return buildTree(null);
};
